import b from 'b_';
import cx from 'classnames';
import QRCode from 'qrcode.react';
import React from 'react';

import { QR_CODE_SIZE, QR_CODE_BG_COLOR } from '../constants';

import './qr-generator.scss';

interface Props {
    url: string;
    size?: QR_CODE_SIZE;
    bgColor?: QR_CODE_BG_COLOR;
    mix?: string;
}

const QrGenerator = ({ url, size = QR_CODE_SIZE.M, bgColor = QR_CODE_BG_COLOR.WHITE, mix }: Props) => {
    return (
        <QRCode
            bgColor={bgColor}
            className={cx(b('qr-code', { size: size }), mix)}
            imageSettings={{
                src: 'https://e7n.s3.yandex.net/static/common/logo.svg',
                height: 30,
                width: 30,
                excavate: true,
            }}
            level="M"
            renderAs="svg"
            value={url}
        />
    );
};

QrGenerator.QR_CODE_SIZE = QR_CODE_SIZE;
QrGenerator.QR_CODE_BG_COLOR = QR_CODE_BG_COLOR;

export default QrGenerator;
